// @flow

export const styles = {
  container: {
    height: 620,
    background: '#68CEF1',
    backgroundImage: 'linear-gradient(90deg, #2A90E9 0%, #39D8FC 100%)',
    boxShadow: '0 4px 10px 0 rgba(104,206,241,0.44)',
    overflow: 'hidden'
  },
  info: {
    padding: '60px 40px 0 40px'
  },
  taglines: {
    marginBottom: 50
  },
  title: {
    fontFamily: '"Nunito", sans-serif',
    fontWeight: 600,
    fontSize: 35,
    color: 'white',
    textShadow: '0 2px 2px rgba(47,55,85,0.10)'
  },
  subTitle: {
    opacity: 0.7,
    fontFamily: '"Nunito", sans-serif',
    fontWeight: 600,
    fontSize: 18,
    color: 'white',
    lineHeight: '27px'
  },
  button: {
    background: '#FFF378',
    borderRadius: '100px',
    minWidth: 170,
    minHeight: 40,
    border: 0,
    padding: 0,
    cursor: 'pointer',
    fontFamily: '"Nunito", sans-serif',
    fontWeight: 600,
    fontSize: 14,
    color: 'black'
  },
  scrollNote: {
    marginTop: 60,
    opacity: 0.5,
    fontFamily: '"Nunito", sans-serif',
    fontWeight: 600,
    color: 'white',
    fontSize: 14,
    display: 'flex',
    '& > img': {
      marginRight: 10
    }
  },
  prodImg: {
    marginBottom: -10
  },
  xsHide: {
    display: 'defaut',
    '@media (max-width: 767px)': {
      display: 'none'
    }
  },
  '@media (min-width: 1024px)': {
    info: {
      paddingTop: '130px'
    }
  },
  opacity90: {
    opacity: 0.9
  },
  opacity80: {
    opacity: 0.8
  },
  opacity50: {
    opacity: 0.5
  },
  opacity30: {
    opacity: 0.3
  }
}



// WEBPACK FOOTER //
// ./src/layouts/Styles/HeroHeader.Style.js